class SPAnnouncement extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.messages = [...this.querySelector('.sp-announcement__messages').children];
    this.messages.forEach(message => message.classList.add('sp-announcement__message'));
    this.index = 0;
    this.paused = false;
    this.button = this.querySelector('.sp-announcement__a11y-toggle');
    this.show(0);
    this.button?.addEventListener('click', () => {
      this.paused = !this.paused;
      this.button.setAttribute('aria-label', this.paused ? (this.button.dataset.resumeLabel || 'Resume announcements') : (this.button.dataset.pauseLabel || 'Pause announcements'));
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.textContent = this.paused ? (this.button.dataset.resumeLabel || 'Resume announcements') : (this.button.dataset.pauseLabel || 'Pause announcements');
      this.startTimer();
    }, { signal: this.controller.signal });
    this.startTimer();
  }
  show(index) {
    this.index = index;
    this.messages.forEach((message, i) => {
      message.classList.toggle('is-active', i === index);
      message.setAttribute('aria-hidden', String(i !== index));
    });
  }
  startTimer() {
    clearInterval(this.timer);
    if (this.paused || this.messages.length < 2) return;
    this.timer = setInterval(() => {
      if (!document.hidden) this.show((this.index + 1) % this.messages.length);
    }, Number(this.dataset.interval) || 6000);
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    this.controller?.abort();
    this.controller = null;
  }
}
if (!customElements.get('sp-announcement')) customElements.define('sp-announcement', SPAnnouncement);
